__webpack_require__.p = "/divya_portfolio_deploy/";